"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
function pascalCase(value) {
    return value[0].toUpperCase() + lodash_camelcase_1.default(value).slice(1);
}
exports.default = pascalCase;
